import { ShareType } from "@/common/share";
import { IconName } from "@/components-v2/iconMapping";
import { TMessage, TMessageParam } from "@/i18n/tt";

export type HolderHistoryEntry = {
  id: string;
  icon: IconName;
  event: TMessage;
  description: TMessage;
  date: string;
};

export type HistoryRow<Terms> = { entry: HolderHistoryEntry; terms?: Terms };

export const shareTypeClause = (
  shareTypeId: number | undefined,
  shareTypeById: Map<number, ShareType>,
): TMessage | TMessageParam => {
  const shareType = shareTypeId === undefined ? undefined : shareTypeById.get(shareTypeId);
  return shareType ? { type: "shareType", value: shareType } : { translated: "–" };
};

export const fromTo = (
  from: TMessage | TMessageParam,
  to: TMessage | TMessageParam,
): TMessageParam => ({
  type: "list",
  value: [from, to],
  separator: " → ",
});

export const foldHistory = <Event, Terms>(
  events: Event[],
  rowForEvent: (event: Event, prevTerms: Terms | undefined) => HistoryRow<Terms>,
): HolderHistoryEntry[] =>
  events.reduce<{ rows: HolderHistoryEntry[]; terms?: Terms }>(
    (acc, event) => {
      const row = rowForEvent(event, acc.terms);
      return { rows: [...acc.rows, row.entry], terms: row.terms };
    },
    { rows: [] },
  ).rows;
